module.exports = __webpack_public_path__ + "assets1779866876160/img/error-404.94756dcf.svg";